import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/app/[locale]/jobs/[location]/[microRole]/serp-events.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/app/[locale]/jobs/[location]/[microRole]/update-search.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/components/breadcrumb/breadcrumb-item/breadcrumb-item.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/components/breadcrumb/breadcrumb.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/inputs/inline-search/inline-search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/inputs/research/research.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/components/popular-jobs/popular-job-item.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/components/suggestions-carousel/carousel.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/serp/hero.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/serp/related-blogs.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/components/popular-jobs/popular-jobs.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/serp/serp-page.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/serp/empty-search.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/modules/serp/serp.tsx");
